import {useEffect} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {mb} from "@pg-design/helpers-css";
import {p} from "@pg-design/helpers-css/";
import {BalconyTerraceIcon, GardenIcon, PoiBusIcon, PropertyPlanIcon, SpecialPriceIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {omit} from "@pg-mono/nodash";

import {gtmOfferOpinionsButtonClick} from "../../../tracking/google_tag_manager/gtm_event_offer_opinions";
import {useOfferUserOpinionResults} from "../../hooks/use_offer_user_opinion";
import {opinionsPollLoaderStyle} from "./OfferDetailOpinions";
import {OfferDetailOpinionsResultsItem} from "./OfferDetailOpinionsResultsItem";

interface Props {
    offerId: number;
    propertyId?: number;
    onButtonClick: () => void;
    onError: () => void;
}

export const MIN_VALID_OFFER_OPINION_RESULT = 60;

export const OfferDetailOpinionsResults = (props: Props) => {
    const {opinions, isLoading, isError, isUninitialized} = useOfferUserOpinionResults(props.offerId, props.propertyId);
    const flatsResultText = props.propertyId ? "Wysoki potencjał inwestycyjny" : "Korzystny układ mieszkań";

    useEffect(() => {
        // handle missing valid opinions
        if (opinions) {
            const opinionsValues = Object.values(omit(opinions, ["total_opinions", "offer"]));
            const validOpinions = opinionsValues.filter((val) => {
                return val > MIN_VALID_OFFER_OPINION_RESULT;
            });

            if (validOpinions.length === 0) {
                props.onError();
            }
        }

        if (isError) {
            props.onError();
        }
    }, [isError, isLoading, opinions]);

    if (isLoading || isError || isUninitialized || !opinions) {
        return <Loader css={opinionsPollLoaderStyle} />;
    }

    const onClick = () => {
        props.onButtonClick();
        gtmOfferOpinionsButtonClick("oceń ofertę");
    };

    return (
        <div css={wrapper}>
            <Text variant="headline_6" css={headlineStyle}>
                Nasi użytkownicy cenią tę ofertę za:
            </Text>
            <div css={innerWrapper}>
                <OfferDetailOpinionsResultsItem
                    icon={GardenIcon}
                    results={opinions.environment_and_infrastructure_percent}
                    text="Dobre otoczenie i infrastruktura"
                />
                <OfferDetailOpinionsResultsItem icon={PoiBusIcon} results={opinions.public_transport_access_percent} text="Dobra komunikacja" />
                <OfferDetailOpinionsResultsItem icon={BalconyTerraceIcon} results={opinions.architecture_percent} text="Piękna architektura budynku" />
                {props.propertyId && opinions.property_layout_percent !== 0 && (
                    <OfferDetailOpinionsResultsItem icon={PropertyPlanIcon} results={opinions.property_layout_percent} text="Korzystny układ mieszkania" />
                )}
                <OfferDetailOpinionsResultsItem icon={SpecialPriceIcon} results={opinions.investment_potential_percent} text={flatsResultText} />
            </div>
            <Button variant="filled_primary" css={buttonStyle} onClick={onClick}>
                Oceń ofertę
            </Button>
        </div>
    );
};

const wrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${p(1, 2)};
`;

const headlineStyle = css`
    ${mb(3)};
    width: 100%;
`;

const innerWrapper = css`
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    ${mb(2)}
    gap: calc(${getThemeVariable("globals.baseUnit")} * 2);

    @container (min-width: 400px) {
        ${mb(5)}
        grid-template-columns:  1fr 1fr;
        gap: calc(${getThemeVariable("globals.baseUnit")} * 4);
    }

    // offer detail column container
    @container (min-width: 700px) {
        ${mb(5)}
        grid-template-columns:  1fr 1fr 1fr;
        gap: calc(${getThemeVariable("globals.baseUnit")} * 4);
    }
`;

const buttonStyle = css`
    width: 230px;
`;
import {useEffect} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {mb} from "@pg-design/helpers-css";
import {p} from "@pg-design/helpers-css/";
import {BalconyTerraceIcon, GardenIcon, PoiBusIcon, PropertyPlanIcon, SpecialPriceIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {omit} from "@pg-mono/nodash";

import {gtmOfferOpinionsButtonClick} from "../../../tracking/google_tag_manager/gtm_event_offer_opinions";
import {useOfferUserOpinionResults} from "../../hooks/use_offer_user_opinion";
import {opinionsPollLoaderStyle} from "./OfferDetailOpinions";
import {OfferDetailOpinionsResultsItem} from "./OfferDetailOpinionsResultsItem";

interface Props {
    offerId: number;
    propertyId?: number;
    onButtonClick: () => void;
    onError: () => void;
}

export const MIN_VALID_OFFER_OPINION_RESULT = 60;

export const OfferDetailOpinionsResults = (props: Props) => {
    const {opinions, isLoading, isError, isUninitialized} = useOfferUserOpinionResults(props.offerId, props.propertyId);
    const flatsResultText = props.propertyId ? "Wysoki potencjał inwestycyjny" : "Korzystny układ mieszkań";

    useEffect(() => {
        // handle missing valid opinions
        if (opinions) {
            const opinionsValues = Object.values(omit(opinions, ["total_opinions", "offer"]));
            const validOpinions = opinionsValues.filter((val) => {
                return val > MIN_VALID_OFFER_OPINION_RESULT;
            });

            if (validOpinions.length === 0) {
                props.onError();
            }
        }

        if (isError) {
            props.onError();
        }
    }, [isError, isLoading, opinions]);

    if (isLoading || isError || isUninitialized || !opinions) {
        return <Loader css={opinionsPollLoaderStyle} />;
    }

    const onClick = () => {
        props.onButtonClick();
        gtmOfferOpinionsButtonClick("oceń ofertę");
    };

    return (
        <div css={wrapper}>
            <Text variant="headline_6" css={headlineStyle}>
                Nasi użytkownicy cenią tę ofertę za:
            </Text>
            <div css={innerWrapper}>
                <OfferDetailOpinionsResultsItem
                    icon={GardenIcon}
                    results={opinions.environment_and_infrastructure_percent}
                    text="Dobre otoczenie i infrastruktura"
                />
                <OfferDetailOpinionsResultsItem icon={PoiBusIcon} results={opinions.public_transport_access_percent} text="Dobra komunikacja" />
                <OfferDetailOpinionsResultsItem icon={BalconyTerraceIcon} results={opinions.architecture_percent} text="Piękna architektura budynku" />
                {props.propertyId && opinions.property_layout_percent !== 0 && (
                    <OfferDetailOpinionsResultsItem icon={PropertyPlanIcon} results={opinions.property_layout_percent} text="Korzystny układ mieszkania" />
                )}
                <OfferDetailOpinionsResultsItem icon={SpecialPriceIcon} results={opinions.investment_potential_percent} text={flatsResultText} />
            </div>
            <Button variant="filled_primary" css={buttonStyle} onClick={onClick}>
                Oceń ofertę
            </Button>
        </div>
    );
};

const wrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${p(1, 2)};
`;

const headlineStyle = css`
    ${mb(3)};
    width: 100%;
`;

const innerWrapper = css`
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    ${mb(2)}
    gap: calc(${getThemeVariable("globals.baseUnit")} * 2);

    @container (min-width: 400px) {
        ${mb(5)}
        grid-template-columns:  1fr 1fr;
        gap: calc(${getThemeVariable("globals.baseUnit")} * 4);
    }

    // offer detail column container
    @container (min-width: 700px) {
        ${mb(5)}
        grid-template-columns:  1fr 1fr 1fr;
        gap: calc(${getThemeVariable("globals.baseUnit")} * 4);
    }
`;

const buttonStyle = css`
    width: 230px;
`;
